module.exports = __webpack_public_path__ + "img/wb1t2.6246f387.png";